import { TFunction } from "i18next";
import * as yup from "yup";

const disenrollValidationSchema = (t: TFunction) => {
	return yup.lazy(() => {
		return yup.object().shape({
			reason: yup
				.string()
				.required(t("validations.required"))
		});
	});
};

export default disenrollValidationSchema;
